import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { Info } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { SimpleCard } from "../../../../components";
import { primaryColor, colorTags } from "../../../../constants/variants";
import GridData from "../../../../components/GridData";
import AddPublication from "./AddPublication";
import DeleteDialog from "../../../../components/DeleteDialog";
import { useNavigate } from "react-router-dom";
import EditPublication from "./EditPublication";
import EditIcon from "@mui/icons-material/Edit";
import {
  useGetPublicationsQuery,
  useGetPublicationByIdQuery,
  useCreatePublicationRequestMutation,
  useUpdatePublicationRequestMutation,
  useDeletePublicationRequestMutation,
} from "../../../../features/api/apiSlice";
import { BASE_FILE_URL } from "../../../../constants/apiTags";
import { OpenInNew } from "@mui/icons-material";
import { Bars } from "react-loader-spinner";

const StyledTable = styled(Table)(() => ({
  whiteSpace: "pre",
  "& thead": {
    "& tr": { "& th": { paddingLeft: 0, paddingRight: 0 } },
  },
  "& tbody": {
    "& tr": { "& td": { paddingLeft: 0, textTransform: "capitalize" } },
  },
}));

const PublicationsDataq = [
  {
    id: 1,
    title: "Publication 1",
    documentName: "document1.pdf",
    createdOn: "2023-06-01",
    updatedOn: "2023-06-05",
  },
  {
    id: 2,
    title: "Publication 2",
    documentName: "document2.pdf",
    createdOn: "2023-06-02",
    updatedOn: "2023-06-06",
  },
];

export default function LawsRegulationsPage() {
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const handleEditModalClose = () => setEditModalOpen(false);
  const handleEditModalOpen = () => setEditModalOpen(true);
  const [selectedRow, setSelectedRow] = useState(null);

  const {
    data: PublicationsData,
    isLoading: isLoadingPublicationsData,
    isError: isErrorPublicationsData,
    error: errorPublicationsData,
  } = useGetPublicationsQuery();

  useEffect(() => {
    if (PublicationsData) console.log(PublicationsData);
  }, [PublicationsData]);

  const columns = [
    {
      field: "id",
      headerName: "No.",
      filterable: false,
      renderCell: (index) => index.api.getRowIndex(index.row.id) + 1,
    },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
    },
    {
      field: "documentName",
      headerName: "Document",
      flex: 1,
      renderCell: (params) => (
        <div>
          {" "}
          <IconButton
            href={BASE_FILE_URL + "/" + params?.row?.documentName}
            target="_blank"
            download>
            <OpenInNew color="primary" />
          </IconButton>{" "}
        </div>
      ),
    },
    {
      field: "createdOn",
      headerName: "Created On",
      type: "date",
      flex: 1,
    },
    {
      field: "updatedOn",
      headerName: "Updated On",
      type: "date",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      flex: 1,
      align: "left",
      renderCell: (params) => {
        return (
          <div className="flex">
            {/* <IconButton
              onClick={() =>
                navigate("/posts/publications/" + params?.row?.id)
              }>
              <Info color="primary" />
            </IconButton> */}
            <IconButton
              onClick={() => {
                setEditModalOpen(true);
                setSelectedRow(params?.row);
              }}>
              <EditIcon color="primary" />
            </IconButton>
            <DeleteDialog
              api={useDeletePublicationRequestMutation}
              dialogLabel="Delete Publication"
              id={params?.row?.id}
              name={`${params?.row?.title}`}
            />
          </div>
        );
      },
    },
  ];

  const [modalOpen, setModalOpen] = useState(false);
  const handleModalClose = () => setModalOpen(false);
  const handleModalOpen = () => setModalOpen(true);

  if (isLoadingPublicationsData)
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
        <Bars
          height="40"
          width="40"
          color="#4fa94d"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  return (
    <div style={{ marginLeft: "5%", marginTop: "5%", width: "90%" }}>
      <Button
        variant="contained"
        style={{
          marginBottom: "1%",
          marginLeft: "88%",
          backgroundColor: primaryColor,
        }}
        onClick={handleModalOpen}>
        Add Publication
      </Button>
      <AddPublication
        open={modalOpen}
        onClose={handleModalClose}
        title="Add Publication"
        content="This is the modal content."
        actionText="Close"
      />
      <SimpleCard
        title="Publications List"
        style={{
          marginTop: "2%",
        }}>
        <Box width="100%" overflow="auto">
          <GridData rows={PublicationsData ?? []} columns={columns} />
        </Box>
      </SimpleCard>

      <EditPublication
        data={selectedRow}
        title="Edit Publication"
        open={editModalOpen}
        onClose={handleEditModalClose}
        onSave={handleEditModalClose}
      />
    </div>
  );
}
